import { Box, Typography } from '@mui/material';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './translations.json';

type SupportedLanguage = keyof typeof translations;

export const ProfileHeader = () => {
  const { language } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      mb={4}
    >
      <Typography 
        variant="h3" 
        sx={{ 
          fontWeight: 900,
          color: "whitesmoke",
          // xs (mobile) : h4 (~2.125rem), md (tablette/desktop) : h3 (3rem)
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' } 
        }}
      >
        {content.title}
      </Typography>
    </Box>
  );
};

export default ProfileHeader;
